import React from 'react';

type Props = {
  size?: string | number;
  className?: string;
  color?: string;
};

const TwitterIcon = ({ className, size = 36, color = '#B3B5B6' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
  >
    <defs>
      <path
        id="e3ko7gobaa"
        d="M20.526 5.846c.89-.562 1.573-1.452 1.893-2.513-.833.521-1.754.898-2.736 1.102C18.899 3.551 17.779 3 16.539 3c-2.38 0-4.307 2.035-4.307 4.544 0 .356.036.703.11 1.034-3.58-.19-6.754-1.996-8.88-4.747-.371.673-.583 1.453-.583 2.285 0 1.576.76 2.967 1.917 3.783-.707-.023-1.371-.23-1.953-.568v.056c0 2.202 1.484 4.04 3.458 4.455-.363.107-.742.16-1.137.16-.277 0-.548-.027-.81-.08.548 1.804 2.139 3.12 4.025 3.155-1.476 1.219-3.333 1.944-5.351 1.944-.348 0-.691-.02-1.028-.062C3.907 20.247 6.171 21 8.604 21c7.926 0 12.257-6.924 12.257-12.929 0-.197-.002-.394-.01-.587.841-.641 1.573-1.442 2.149-2.353-.773.361-1.604.606-2.474.715z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-44 -601) translate(20 589) translate(24 12)">
            <mask id="i1ykronp1b" fill={color}>
              <use xlinkHref="#e3ko7gobaa" />
            </mask>
            <use fill={color} xlinkHref="#e3ko7gobaa" />
            <g fill={color} mask="url(#i1ykronp1b)">
              <path d="M0 0H24V24H0z" />
            </g>
            <path d="M0 0H24V24H0z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default TwitterIcon;
